import { Model } from "pinia-orm";
import { COMPANY_ROLES } from "./enums/company-roles";

export default class ContributorBatch extends Model {
  static name = "ContributorBatch";
  static entity = "contributorBatches";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.attr(),
      batchId: this.attr(),
      contributorId: this.attr(null),
      companyProjectRoleId: this.attr(null),
      companyRole: this.attr(COMPANY_ROLES.INCUMBENT_COMPANY),
      incumbentCompanyName: this.attr(""),
    };
  }
}
